import React, { ReactNode, useState } from "react";
import { Accordion as UIAccordion } from "@shoptet/ui";

type AccordionPropsT = {
  children: ReactNode;
  defaultOpened?: boolean;
  header: string;
};

// Thin adapter over the design system's Accordion: it saves every call site the group/item nesting
// and keeps the `Accordion-<header>` test id the Cypress `accordionOpen` command selects on.
//
// The item is controlled rather than left to its own `defaultExpanded`. Inside an `<Accordion>` the
// item reads `expanded` from the group, whose keys always start empty, so `defaultExpanded` is
// treated as the default of an already-controlled value and never applies. Measured: an item with
// `defaultExpanded` still renders collapsed. Owning the state here keeps `defaultOpened` working.
export const Accordion = ({ children, defaultOpened, header }: AccordionPropsT) => {
  const [expanded, setExpanded] = useState(!!defaultOpened);

  return (
    <UIAccordion withBackground>
      <UIAccordion.Item
        data-test-id={`Accordion-${header}`}
        expanded={expanded}
        title={header}
        onExpandedChange={setExpanded}
      >
        {children}
      </UIAccordion.Item>
    </UIAccordion>
  );
};
